module.exports = __webpack_public_path__ + "img/icon-chevron.ac53047c.svg";